<div class="cards">
  <div class="cards__header">
    <div class="cards__title block-title" [innerHTML]="'t.lootboxes' | translate | safe: 'html'"></div>

    @if (user.auth) {
      @if (bonusShopType === BONUS_SHOP_TYPE.CASH) {
        <div class="cards__points">
          {{ user.currentCurrency.currency }} <br>
          <div>{{ user.currentCurrency.amount }}</div>
        </div>
      }

      @if (bonusShopType === BONUS_SHOP_TYPE.COINS) {
        <div class="cards__points">
          {{ 't.points' | translate }} <br>
          <div>{{ compPoints.points?.chargeable | number }}</div>
        </div>
      }
    }
  </div>
  <div class="cards__list">
    @for (bonus of bonusStorePage?.Goods; track $index) {
      <div class="cards__list_item box">
        <div class="top-info">
          <div class="top-info__text">
            <div class="top-info__text_title" [innerHTML]="bonus?.Title | safe: 'html'"></div>
            <div class="top-info__text_rule" [innerHTML]="bonus?.Rule | safe: 'html'"
                 [ngClass]="{
                   'top-info__text_rule--cash': bonusShopType === BONUS_SHOP_TYPE.CASH,
                   'not-auth': bonusShopType === BONUS_SHOP_TYPE.CASH && !user.auth
                 }"
            ></div>
            @if (bonusShopType === BONUS_SHOP_TYPE.COINS) {
              <div class="top-info__text_price">
                {{ 't.shop-price' | translate }} {{ bonus?.PointsCost }} {{ 't.points' | translate }}
              </div>
            }

            @if (bonusShopType === BONUS_SHOP_TYPE.CASH) {
              @if (user.auth && bonus?.GoodsPrices?.price?.[user.currentCurrency.currency]) {
                <div class="top-info__text_price">
                  {{ 't.shop-price' | translate }}
                  {{ bonus?.GoodsPrices?.price?.[user.currentCurrency.currency] }} {{ user.currentCurrency.currency }}
                </div>
              }
            }
          </div>

          <img [src]="bonus?.image" [alt]="bonus?.Title + ' - Spinpanda casino'" class="top-info__img">
        </div>
        <div class="desc" [innerHTML]="bonus?.Description | safe: 'html'">

        </div>
        <div class="actions">
          @if (user.auth) {
            @if (bonusShopType === BONUS_SHOP_TYPE.COINS) {
              @if (bonus?.isCanBuyLootbox) {
                <button class="btn btn--filled-primary"
                        (click)="showBonusStoreModal(bonus, bonus.image, bonusStorePage.Goods, bonusShopType)">{{ 't.buy-now' | translate }}
                </button>
              } @else {
                @if (bonus?.unlockMessage) {
                  <button class="btn--locked">
                    <i class="icon-locked"></i>
                    <div [innerHTML]="bonus?.unlockMessage | safe: 'html'"></div>
                  </button>
                } @else {
                  <button class="btn--locked preload"></button>
                }
              }
            }

            @if (bonusShopType === BONUS_SHOP_TYPE.CASH) {
              @if (user.currentCurrency.amount >= bonus?.GoodsPrices?.price?.[user.currentCurrency.currency]) {
                <button class="btn btn--filled-primary"
                        (click)="showBonusStoreModal(bonus, bonus.image, bonusStorePage.Goods, bonusShopType)">{{ 't.buy-now' | translate }}
                </button>
              } @else {
                <button class="btn btn--filled-secondary small" routerLink="/deposit">
                  {{ 't.deposit' | translate }}
                </button>
              }
            }

          } @else {
            <button class="btn btn--filled-primary" (click)="user.authUser()">{{ user.authKeyTranslate | translate }}
            </button>
          }

          <span class="link"
                (click)="showBonusStoreModal(bonus, bonus.image, bonusStorePage.Goods, bonusShopType)">{{ 't.see-rewards' | translate }}</span>
        </div>
      </div>
    }
  </div>
</div>

<div class="steps">
  <div class="steps__title block-title" [innerHTML]="bonusStorePage.HowEarnTitle | safe: 'html'"></div>
  <div class="steps__list">
    @for (step of bonusStorePage.HowEarnSteps; track $index) {
      <div class="steps__list_item">
        <span>{{ $index + 1 }}</span>
        <h6 [innerHTML]="step?.Title | safe: 'html'"></h6>
      </div>
    }
  </div>
</div>
@if (bonusStorePage?.Terms) {
  <app-terms [content]="bonusStorePage?.Terms"></app-terms>
}
